import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=436ed83a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=436ed83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ed83a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436ed83a')) {
      api.createRecord('436ed83a', component.options)
    } else {
      api.reload('436ed83a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=436ed83a&scoped=true&", function () {
      api.rerender('436ed83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uz8KARlUcON6/JS/teamMember.vue"
export default component.exports